//Declare Important Variables.
var g_bCancelDialog = true;
var g_objChanges = {};
var initBookmark = false;
var g_bInitialDialog = true;
let g_isOldBuildShareLink = false;

// To support backwards compatibility with old links we will first check for a '#',
// then we will convert to a '?' for use with the updated share logic
if (window.location.hash.length > 0) {
  const updatedShareUrl = window.location.href.replace("#", "?");
  window.history.pushState({}, "", updatedShareUrl);
  g_isOldBuildShareLink = true;
}
const hash = window.location.search.slice(1).toString();

/*****************************************************************
function:   loadMapBundle
Desc.:      Replaces the Dojo `require(['Javascript/map'])` boundary. Dynamically imports the
            ESM map bundle (built by esbuild → /<lang>/js/map.bundle.js, bundling @arcgis/core).
            Dynamic import() is valid in classic scripts. Resolves to the bundle's module
            namespace: `.default` = the map API (init/displayMap/…), plus named `MapModel` and
            `FeatureLayer` for the customTable.js / nameValueLib.js boundary consumers.
            The shell page is /<lang>/index.html (or embed-view.html), so the js dir is
            /<lang>/js/ regardless of the loaded partial.
return:     Promise<module namespace>
*****************************************************************/
window.loadMapBundle = function() {
  var dir = window.location.pathname.replace(/\/[^/]*$/, '/'); // strip filename → /<lang>/
  return import(dir + 'js/map.bundle.js');
};

/************** VARIABLES FOR Countries.js **************/
var objCountries = [];
var bCountryDataLoaded = false;

var arrPrevSelectedCountryCodes = [];

var arrSelectedSubRegions = [];
var arrSelectedCountryCodes = [];
var arrSelectedCountryNames = [];
var loadFromHash = false;

/************** VARIABLES FOR Indicators.js **************/
var arrCompleteIndicatorList = [];
var arrIndicatorByTagList = [];
var arrCommonIndicatorList = [];
var arrIndicatorMetaData = [];
var bIndicatorDataLoaded = false;
var objIndicatorDenominatorInfo = {};
var g_nMinTagID = 1000;
var g_nMaxTagID = g_nMinTagID;
var arrPrevSelectedIndicatorCodes = [];
var arrPrevSelectedDenominatorIndicators = [];

var arrSelectedIndicatorCodes = [];
var arrSelectedIndicatorNames = [];

var arrIndicatorMeasurementType = [];
var arrSelectedDenominatorIndicators = [];
var arrSelectedDenominatorIndicatorsCount = [];
var arrLoadedDenominatorIndicators = [];

/************** VARIABLES FOR Data.js **************/
var arrData;
var arrSortDataProperties = [];

var g_arrCheckedCountryCodes = [];
var g_arrUnCheckedCountryCodes = [];
var g_arrCheckedCharLabels = [];
const g_arrCurrSurveyRange = [];

var g_nInitialDisplayType = "0";
var g_nInitialPivotType = "0";
var g_strSurveySelection = "All";
var g_arrSharedUnselectedSurveys = [];
var g_nMapLevelRank = 0;
var g_strBreakType = "Natural";
var g_arrCustomBreaks = [
  [
    { breakLevel: 1, value: "" },
    { breakLevel: 2, value: "" }
  ],
  [
    { breakLevel: 1, value: "" },
    { breakLevel: 2, value: "" },
    { breakLevel: 3, value: "" }
  ],
  [
    { breakLevel: 1, value: "" },
    { breakLevel: 2, value: "" },
    { breakLevel: 3, value: "" },
    { breakLevel: 4, value: "" }
  ],
  [
    { breakLevel: 1, value: "" },
    { breakLevel: 2, value: "" },
    { breakLevel: 3, value: "" },
    { breakLevel: 4, value: "" },
    { breakLevel: 5, value: "" }
  ]
];
var g_bCustBrksFromShare = false;
var controlPanelIsOpen = false;
var g_Embed = false;
var introjs;

/************** VARIABLES FOR statCompilerDashboard.js **************/
var objUniqueLevelNaByCountryAndLevelRnk = {};
var objUniqueLvlNames = {};
var objUniqueLevelNaByLevelRnk = {};
var objLevelRnkWithDuplicateLevelNa = {};
var objMapLevelLabels = {}; // populated in statCompilerDashboard.js, used in map.js and MapModal.js
var objMapLevelLabelConflicts = {};

/************** CONSTANTS FOR Google Analytics **************/

var PV_BOOKMARK = "/bookmark";
var PV_WELCOME = "/welcome";
var PV_GRID = "/grid";
var PV_LINECHART = "/linechart";
var PV_COLUMNCHART = "/columnchart";
var PV_MAP = "/map";
var PV_GUIDEDHELP = "/guidedhelp";
var TITLE_MAIN = "Main Page";
var TITLE_DATA = "Data Page";

/***********************************************************************
Object.watch polyfill - allows for watching for changes in the value of a property of an object.
param:      property_name: The string value of the property to observe
param:      callback: The function to call when a change is detected. Receives three arguments: prop, oldval, newval
prop = the property
oldval = value prior to change
newval = value that the property is being set to

callback should return the final value the property should be set to. Returning nothing prevents the property's value from changing.

Note: native implementation is Object.watch; Our polyfill exists separately under the method name 'obj_watch' to avoid issues in Firefox which implements natively but overloading causes errors.
*****************************************************************/

if (!Object.prototype.obj_watch) {
  Object.defineProperty(Object.prototype, "obj_watch", {
    enumerable: false,
    configurable: true,
    writable: false,
    value: function(prop, handler) {
      var oldval = this[prop],
        newval = oldval,
        getter = function() {
          return newval;
        },
        setter = function(val) {
          oldval = newval;
          return (newval = handler.call(this, prop, oldval, val));
        };
      if (delete this[prop]) {
        // can't watch constants
        Object.defineProperty(this, prop, {
          get: getter,
          set: setter,
          enumerable: true,
          configurable: true
        });
      }
    }
  });
}

window.obj_watch("_curDisplayType", function(prop, oldval, newval) {
  if (oldval == newval) return newval;

  if (oldval !== undefined) new State($("#pivotMenu .dropdown-menu ul")[0]);

  $("body").attr("data-current_display_type", newval.toLowerCase());
  var $label = $("#lstCharLabels li.jstree-node").filter(function() {
    var text = $(this)
      .text()
      .toLowerCase();
    return text == "region" || text == "région";
  });
  $label.addClass("region_charLabel");

  if (oldval == "Grid") {
    // If previously we were in Grid view and had multiple selected, switch to the preferred value for each.
    _.toArray(byVariableState.all()).forEach(function(v) {
      if (v.current.length > 1) {
        v.current = [v.preferred];
      }
    });
    statCompilerDashboard.updateDashboard(null, true);
  }
  // Here is also where we can adjust the actual data if needed.
  return newval;
});

/*****************************************************************
function:   OnDocumentReady
Desc.:      JQuery function that is called once the page is loaded.
						You need to add all your events in here to make sure
						they are executed after the document is loaded.
*****************************************************************/
$(document).ready(function() {
  //Add cors support for IE9.
  $.support.cors = true;

  fullScreenInit();
  mobileDetectInit();

  var curPage = "home.html";

  //Obtain the locale from the path.
  var strPath = window.location.pathname;
  strPath = strPath.substr(strPath.lastIndexOf("/") - 2, 2);
  if (strPath.length > 0) {
    Config.setLanguage(strPath);
  }

  //Obtain the locale of the browser.
  //var browserLocale = navigator.language.substr(0,2);

  //Setup Decimal Point for High Charts.
  if (Config.getLanguage() == Config.LANGUAGE.FRENCH) {
    Highcharts.setOptions({
      lang: {
        decimalPoint: ","
      }
    });
  } else {
    Highcharts.setOptions({
      lang: {
        decimalPoint: "."
      }
    });
  }

  //Check if there are query parameters in the URL, for bookmarks/direct URL.
  /*
		cc  = Country codes used for data display.
		ic  = Indicator codes used for data display.
		scl = Selected Char Labels within the Indicators selector.
		scc = Selected country codes within the country selector.
		dt  = Grid (0), Column (1), Line (2), Map (3)
		pt  = Pivot Type. Possible values: Survey (0), Indicator (1), SurveyChar (2), CharSurvey (3)
		rs  = All Surveys (0), Recent Surveys (1)
	*/
  if (
    window.location.search.length > 0 &&
    window.location.search.indexOf("ic=") > -1 &&
    window.location.search.indexOf("cc=") > -1
  ) {
    //Variabes for Countries.
    loadIndicatorsData();
    loadFromHash = true;
    curPage = "data.html";
  } else {
    //Send GA pageview (new user).
    if (typeof ga !== "undefined") {
      ga("set", { page: PV_WELCOME, title: TITLE_MAIN });
      ga("send", "pageview");
    }
    if (typeof gtag !== "undefined") {
      gtag("event", "pageview", {
        event_page: PV_WELCOME,
        event_title: TITLE_MAIN
      });
    }
    loadIndicatorsData();
    loadPage(curPage);
    localStorage.setItem("startedGuidedHelp", false);
    localStorage.setItem("startedTour_col", false);
    localStorage.setItem("startedTour_grid", false);
    localStorage.setItem("startedTour_map", false);
    localStorage.setItem("startedTour_line", false);
  }

  //Load Countries data for future usage.
  loadCountriesData();

  //Initial Load.
});

var showWelcome = function() {
  ga("set", { page: PV_GUIDEDHELP, title: TITLE_MAIN });
  ga("send", "pageview");
  gtag("event", "pageview", {
    event_page: PV_GUIDEDHELP,
    event_title: TITLE_MAIN
  });

  statCompilerDashboard.startTour();
  // Below items are used to start the tours automatically in data page
  localStorage.setItem("startedTour_grid", true);
  localStorage.setItem("startedTour_line", true);
  localStorage.setItem("startedTour_col", true);
  localStorage.setItem("startedTour_map", true);
  localStorage.setItem("startedGuidedHelp", true);
};

var initHash = function(all_countries) {
  var all_countries = all_countries;
  loadFromHash = false;
  window.original_hashstring = window.location.search.toString();
  curPage = "data.html";
  loadPage(curPage);

  var strCountryIds = "";
  var arrCountryIds = [];
  var arrCountryNames = [];

  //Variables for Indicators.
  var strIndicatorIds = "";
  var arrIndicatorIds = [];
  var arrIndicatorNames = [];
  var arrDenominatorIndicatorsIds = [];

  //Variables for Selected Countries and Char Labels.
  var arrCheckedCountries = [];
  var arrCheckedCharLabels = [];

  var objResult = { Data: [] };
  var objParams = {};

  var containsAllCountries = false;

  // Get survey year range
  const surveyYearRange = getQueryVariable("syr");
  if (surveyYearRange) {
    const [minShareYear, maxShareYear] = surveyYearRange.split("-");
    minYear = minShareYear;
    maxYear = maxShareYear;
  }

  ///Obtain the Country Codes.
  strCountryIds = getQueryVariable("cc");
  if (strCountryIds.toLowerCase() == "all") {
    containsAllCountries = true;
    strCountryIds = all_countries.Data.map(function(v) {
      return v.DHS_CountryCode;
    }).join(",");
  }

  //If their are country codes, try and look for indicator codes.
  if (strCountryIds.length != 0) {
    //Obtain the Indicator Codes.
    strIndicatorIds = getQueryVariable("ic");
    //If their are indicator Codes, try and setup the data variables.
    if (strIndicatorIds && strIndicatorIds.length != 0) {
      if (containsAllCountries) {
        objResult = all_countries;
      } else {
        //Obtain country names.
        objParams["countryIds"] = strCountryIds;
        objParams["returnFields"] = "DHS_CountryCode,CountryName";

        objResult = dhsAPI.getCountries(objParams, false);
      }
      //Save Country codes and names in an array.
      $.each(objResult.Data, function(index, objRow) {
        //if(objRow.DHS_CountryCode === 'CI'){objRow.CountryName = "Cote d'Ivoire";}
        arrCountryIds.push(objRow.DHS_CountryCode);
        arrCountryNames.push(objRow.CountryName);
      });

      //Validate that the country codes specified in the URL are all valid.
      //If valid, proceed to verifying the indicator codes.
      if (strCountryIds.split(",").length == arrCountryIds.length) {
        var arrDenominatorIndicators = arrSelectedDenominatorIndicators
          .map(function(objRow) {
            var string =
              objRow.IndicatorSpecial1Id !== ""
                ? objRow.IndicatorSpecial1Id + ","
                : "";
            string +=
              objRow.IndicatorSpecial2Id !== ""
                ? objRow.IndicatorSpecial2Id + ","
                : "";
            string +=
              objRow.IndicatorTotalId !== ""
                ? objRow.IndicatorTotalId + ","
                : "";
            string +=
              objRow.DenominatorUnweightedId !== ""
                ? objRow.DenominatorUnweightedId + ","
                : "";
            string +=
              objRow.DenominatorWeightedId !== ""
                ? objRow.DenominatorWeightedId + ""
                : "";

            return string;
          })
          .join(",");
        //Obtain Indicator Names.
        objParams = {};

        objParams["indicatorIds"] =
          strIndicatorIds + "," + arrDenominatorIndicators;
        // 				objParams["indicatorIds"] = strIndicatorIds;
        //IndicatorId,Label,DenominatorSpecial1Id,DenominatorSpecial2Id,DenominatorWeightedId,DenominatorTotalId,DenominatorUnweightedId,Level1,Level2,Level3,IndicatorOldId,ShortName,MeasurementType,NumberScale,Definition,IsQuickStat,IndicatorType,SDRID,TagIds,QuickStatOrder,Denominator,DenominatorUnweightedId,DenominatorWeightedId
        objParams["returnFields"] =
          "IndicatorId,Label,DenominatorWeightedId,DenominatorUnweightedId,Denominator,IndicatorSpecial1Id,IndicatorSpecial2Id,IndicatorTotalId";
        objResult = dhsAPI.getIndicators(objParams, false);
        //objResultRequest = dhsAPI.getIndicators(objParams, true);
        //Save Indicator codes and names in an array.
        // 				$.each(objResult.Data, function(index, objRow) {
        for (var index in objResult.Data) {
          var objRow = objResult.Data[index];
          arrIndicatorIds.push(objRow.IndicatorId);

          if (
            objRow.IndicatorSpecial1Id !== "" &&
            arrDenominatorIndicatorsIds.indexOf(objRow.IndicatorSpecial1Id) ===
              -1
          ) {
            arrDenominatorIndicatorsIds.push(objRow.IndicatorSpecial1Id);
          }
          if (
            objRow.IndicatorSpecial2Id !== "" &&
            arrDenominatorIndicatorsIds.indexOf(objRow.IndicatorSpecial2Id) ===
              -1
          ) {
            arrDenominatorIndicatorsIds.push(objRow.IndicatorSpecial2Id);
          }
          if (
            objRow.IndicatorTotalId !== "" &&
            arrDenominatorIndicatorsIds.indexOf(objRow.IndicatorTotalId) === -1
          ) {
            arrDenominatorIndicatorsIds.push(objRow.IndicatorTotalId);
          }
          if (
            objRow.DenominatorUnweightedId !== "" &&
            arrDenominatorIndicatorsIds.indexOf(
              objRow.DenominatorUnweightedId
            ) === -1
          ) {
            arrDenominatorIndicatorsIds.push(objRow.DenominatorUnweightedId);
          }
          if (
            objRow.DenominatorWeightedId !== "" &&
            arrDenominatorIndicatorsIds.indexOf(
              objRow.DenominatorWeightedId
            ) === -1
          ) {
            arrDenominatorIndicatorsIds.push(objRow.DenominatorWeightedId);
          }
          // arrDenominatorIndicatorsIds.push({
          // 	IndicatorSpecial1Id: objRow.IndicatorSpecial1Id,
          // 	IndicatorSpecial2Id: objRow.IndicatorSpecial2Id,
          // 	IndicatorTotalId: objRow.IndicatorTotalId,
          // 	DenominatorUnweightedId: objRow.DenominatorUnweightedId,
          // 	DenominatorWeightedId: objRow.DenominatorWeightedId
          // });
          arrIndicatorNames.push(objRow.Label);
        }

        //Validate that the indicator codes specified in the URL are all valid.
        //If valid, proceed to assigning all global variables and loading the data.
        if (strIndicatorIds.split(",").length == arrIndicatorIds.length) {
          //Obtain the checked Char Labels.
          if (getQueryVariable("scl")) {
            g_arrCheckedCharLabels = getQueryVariable("scl").split(",");
            //Converting string to integers as char label ids are always numbers.
            $.each(g_arrCheckedCharLabels, function(index, val) {
              g_arrCheckedCharLabels[index] = parseInt(val);
            });
          }

          //Obtain the un-checked country codes.
          if (getQueryVariable("ucc")) {
            //Obtain the plain country codes array.
            var arrTemp = getQueryVariable("ucc").split(",");
            var remainingCountryIds = _.difference(arrCountryIds, arrTemp);

            //Create the name value Lib Array from the plain array.
            $.each(arrCountryIds, function(index, countryCode) {
              var objTemp;
              //If country is checked.
              if (remainingCountryIds.indexOf(countryCode) != -1) {
                objTemp = nameValueLib.createObject(
                  countryCode,
                  "",
                  true,
                  false
                );
              } else {
                //Country Code is not checked.
                objTemp = nameValueLib.createObject(
                  countryCode,
                  "",
                  false,
                  false
                );
                g_arrUnCheckedCountryCodes.push(objTemp);
              }
              g_arrCheckedCountryCodes.push(objTemp);
            });
          } else if (getQueryVariable("scc")) {
            //Obtain the plain country codes array.
            var arrTemp = getQueryVariable("scc").split(",");

            //Create the name value Lib Array from the plain array.
            $.each(arrCountryIds, function(index, countryCode) {
              var objTemp;
              //If country is checked.
              if (arrTemp.indexOf(countryCode) != -1) {
                objTemp = nameValueLib.createObject(
                  countryCode,
                  "",
                  true,
                  false
                );
              } else {
                //Country Code is not checked.
                objTemp = nameValueLib.createObject(
                  countryCode,
                  "",
                  false,
                  false
                );
              }

              g_arrCheckedCountryCodes.push(objTemp);
            });
          }

          //Obtain the display type.
          if (getQueryVariable("dt")) {
            g_nInitialDisplayType = getQueryVariable("dt");
            g_nInitialDisplayType = parseInt(g_nInitialDisplayType) || 0;
          }

          //Obtain the pivot type.
          if (getQueryVariable("pt")) {
            g_nInitialPivotType = getQueryVariable("pt");
            g_nInitialPivotType = parseInt(g_nInitialPivotType) || 0;
          }

          // Get type of survey selection query param.
          if (getQueryVariable("ss")) {
            var nSelection = getQueryVariable("ss");
            nSelection = parseInt(nSelection) || 0;

            // Handle backwards compatibility
            if (g_isOldBuildShareLink) {
              g_strSurveySelection =
                nSelection === 1
                  ? statCompilerDashboard.SURVEY_SELECTION.Recent
                  : statCompilerDashboard.SURVEY_SELECTION.All;
            } else {
              //Obtain the actual survey selection. In this case the dates are unselected surveys.
              switch (nSelection) {
                case 1:
                  g_strSurveySelection =
                    statCompilerDashboard.SURVEY_SELECTION.Custom;
                  //If it is a custom survey, make sure there are years by country
                  const strUnselectedSurveysParam = getQueryVariable("sy");

                  if (strUnselectedSurveysParam) {
                    const parsedSurveysQuery = [];
                    // Parse the query string
                    // Expected string format example: sy=BF-1993+2017_BO-1989
                    const countriesAndSurveys = strUnselectedSurveysParam.split(
                      "_"
                    );
                    for (const country of countriesAndSurveys) {
                      let name = "";
                      let value = [];
                      const [alias, surveyYears] = country.split("-");

                      if (surveyYears === "") {
                        continue;
                      }

                      // Get country full name from alias
                      for (const item of global_all_countries) {
                        if (item.value === alias) {
                          name = item.name;
                          break;
                        }
                      }

                      const splitSurveyYears = surveyYears.split("+");
                      if (splitSurveyYears.length > 0) {
                        value = splitSurveyYears.map(year => parseInt(year));
                        parsedSurveysQuery.push(
                          nameValueLib.createObject(name, alias, value, false)
                        );
                      }
                    }

                    g_arrSharedUnselectedSurveys = parsedSurveysQuery;
                  } else {
                    g_strSurveySelection =
                      statCompilerDashboard.SURVEY_SELECTION.All;
                  }
                  break;
                case 0:
                  g_strSurveySelection =
                    statCompilerDashboard.SURVEY_SELECTION.All;
                  break;
                default:
                  g_strSurveySelection =
                    statCompilerDashboard.SURVEY_SELECTION.All;
                  break;
              }
            }
          }

          //Obtain variable for Geo Type. i.e. decide whether map shows as National or Subnational.
          if (getQueryVariable("lvlRnk")) {
            g_nMapLevelRank = parseInt(getQueryVariable("lvlRnk"));
          }

          //Check if the URL is being used to embed in another page.
          if (getQueryVariable("em")) {
            g_Embed = parseInt(getQueryVariable("em"));
          }

          // user selected indicator
          if (getQueryVariable("si")) {
            var selIndi = parseInt(getQueryVariable("si"));
            // alert(selIndi);
          }

          // user selected byVariable
          if (getQueryVariable("sbv")) {
            var selByVar = parseInt(getQueryVariable("sbv"));
            // alert(selByVar);
          }

          // Break type and custom breaks
          if (getQueryVariable("brk")) {
            const breakSelection = getQueryVariable("brk");
            g_strBreakType = breakSelection;

            if (breakSelection === "Custom") {
              const customBreaksStr = getQueryVariable("custbrks");
              if (customBreaksStr) {
                g_bCustBrksFromShare = true;
                const customBreaks = customBreaksStr.split("+");
                for ([breakLevel, breaks] of customBreaks.entries()) {
                  for ([idx, breakVal] of breaks.split(",").entries()) {
                    g_arrCustomBreaks[breakLevel][idx].value = breakVal;
                  }
                }
              }
            }
          }

          //Assign all the variables.
          //Country Codes.
          arrSelectedCountryCodes = arrCountryIds;
          arrSelectedCountryNames = arrCountryNames;

          //Indicator Codes.
          arrSelectedIndicatorCodes = arrIndicatorIds;
          arrSelectedIndicatorNames = arrIndicatorNames;
          arrSelectedDenominatorIndicators = arrDenominatorIndicatorsIds;

          //Set Current Page to be the data page.
          curPage = "data.html";
        }
      }
    }
  }
  //Send GA pageview (bookmarked user).
  if (typeof ga !== "undefined") {
    ga("set", { page: PV_BOOKMARK, title: TITLE_MAIN });
    ga("send", "pageview");
  }
  if (typeof gtag !== "undefined") {
    gtag("event", "pageview", {
      event_page: PV_BOOKMARK,
      event_title: TITLE_MAIN
    });
  }
};

//! loadPage
/*****************************************************************
function:   loadPage
Desc.:      Setup a function to help with page loads.
*****************************************************************/
var loadPage = function(pagePath) {
  //Load into appropriate div.
  $("#contentDiv").load("html/" + pagePath, function() {
    if (pagePath == "countries.html") {
      loadCountries(false);
      //setTimeout(function(){loadCountries();},200);
    } else if (pagePath == "indicators.html") {
      loadIndicators(false);
      //setTimeout(function(){loadCountries();},200);
    } else if (pagePath == "data.html") {
      loadData();
      // 			setTimeout(loadData,2000);
    }

    if (document.all && !window.atob) {
      ie9Loader();
    }
  });

  if (window.location.search.length > 0 && !localStorage.NO_REMOVE_HASH) {
    const hashStrippedUrl = window.location.origin + window.location.pathname;
    window.history.pushState({}, "", hashStrippedUrl);
  }

  return false;
};

/*****************************************************************
function:   toggleFullScreen
Desc.:      Function to switch browser into full screen mode.
return:     void
*****************************************************************/
var toggleFullScreen = function() {
  console.error("Fullscreen handler not loaded");
};

var toggleHTLM5FullScreen = function() {
  $(document).toggleFullScreen();

  //Update Dashboard.
  setTimeout(function() {
    statCompilerDashboard.updateDashboard(null);
  }, 2000);
};

var toggleCSSFullScreen = function() {
  $(document.body.parentNode).toggleClass("fullscreen-enabled");

  //Update Dashboard.
  setTimeout(function() {
    statCompilerDashboard.updateDashboard(null);
  }, 2000);
};

/*****************************************************************
function:   fullScreenInit
Desc.:      Function to setup fullscreen handling for native
			support and workaround
return:     void
*****************************************************************/
var fullScreenInit = function() {
  // yepnope.injectJS
  if (Modernizr.fullscreen) {
    yepnope.injectJs(
      { src: "./js/external/jquery-fullscreen/jquery.fullscreen.js" },
      function() {
        window.toggleFullScreen = toggleHTLM5FullScreen;
      }
    );
  } else {
    window.toggleFullScreen = toggleCSSFullScreen;
  }
};

/*****************************************************************
function:   mobileDetectInit
Desc.:      Sets up mobile detection in global window.mobileDetect
return:     void
*****************************************************************/
var mobileDetectInit = function() {
  // mobile-detect.min.js is now loaded as a plain global <script> (UMD → window.MobileDetect),
  // replacing the Dojo `require(['External/mobile-detect…'])` AMD path.
  if (typeof MobileDetect !== "undefined") {
    window.mobileDetect = new MobileDetect(window.navigator.userAgent);
  }
};

/*****************************************************************
function:   showBookmark
Desc.:      Shows bookmark in share dialog
return:     void
*****************************************************************/
var showBookmark = function() {
  $("#shareContainer").addClass("hidden");
  $(".bookmark-content-container").removeClass("hidden");
  $("input[type='text']").select();
};

/*****************************************************************
function:   setSelectSurveyTypeText
Desc.:      Checks the value of each checkbox of the surveys within a given year range
            to find which are selected and applies the correct text to the select survey 
            type dropdown
return:     void
*****************************************************************/
const setSelectSurveyTypeText = () => {
  const minYear = parseInt($("#dateMin").val());
  const maxYear = parseInt($("#dateMax").val());
  // Check if there is a mixed set of survey types enabled
  const surveyCells = $("#customTable").find("td.check");
  const surveySelectedStates = {};
  surveyCells.each(function() {
    const cell = $(this);
    const className = cell.attr("class");
    const year = parseInt(className.split(" ").pop()); //Get year from class
    // Only check values in the set survey year range
    if (year >= minYear && year <= maxYear) {
      const surveyLabelElement = cell.find("p")[0];
      if (surveyLabelElement) {
        // Cell has survey information
        const surveyType = cell.find("p")[0].innerText;
        const isChecked = cell.find("input")[0].value === "1" ? true : false;
        if (surveyType) {
          if (surveySelectedStates[surveyType]) {
            surveySelectedStates[surveyType].push(isChecked);
          } else {
            surveySelectedStates[surveyType] = [isChecked];
          }
        }
      }
    }
  });

  const surveysWithAllYearsSelected = [];
  const surveysWithAnyYearsSelected = [];
  const surveysWithNoYearsSelected = [];
  const numSurveyTypes = Object.keys(surveySelectedStates).length;

  for (const surveyType in surveySelectedStates) {
    const allEnabled = surveySelectedStates[surveyType].every(
      state => state === true
    );
    const allDisabled = surveySelectedStates[surveyType].every(
      state => state === false
    );

    if (!allDisabled && !allEnabled) {
      surveysWithAnyYearsSelected.push(surveyType);
    } else if (allEnabled) {
      surveysWithAllYearsSelected.push(surveyType);
    } else if (allDisabled) {
      surveysWithNoYearsSelected.push(surveyType);
    }
  }

  // Assign appropriate text and value to the select a type dropdown
  let surveyTypeSelectText = null;

  if (surveysWithAllYearsSelected.length === numSurveyTypes) {
    surveyTypeSelectText = Config.getUniversalString("All");
  } else if (surveysWithNoYearsSelected.length === numSurveyTypes) {
    surveyTypeSelectText = Config.getUniversalString("None");
  } else if (
    surveysWithAllYearsSelected.length === 1 &&
    surveysWithNoYearsSelected.length === numSurveyTypes - 1
  ) {
    surveyTypeSelectText = surveysWithAllYearsSelected[0];
  } else {
    surveyTypeSelectText = Config.getUniversalString("Mixed");
  }

  $("#surveySelector-button .ui-selectmenu-text").text(surveyTypeSelectText);
};

/**
 * @fn addParametersPopup
 * @brief   Function used to add/remove countries or indicators
*           to/from the data.
 * @param   strContainer: The id or class to use to display the dialog.
 * @param   paramType: String specifying whether the paramater type is countries or indicators.
 * @param   initialDisplay: Boolean specifying whether this dialog is being displayed as an initial
							addition of parameters, or being displayed in the tool to allow
							adding or removing more indicators/countries.
 * @return  void
 */
var addParametersPopup = function(
  strContainer,
  dataType,
  initialDisplay,
  popupTitle
) {
  //Declare Important Variables.
  var centerPosition = {
    my: "center",
    at: "center",
    of: document.body
  };

  var strTitle = popupTitle;
  var appendToDiv = "body";

  var width = 500;

  if (dataType == "dataError") {
    width = 450;
  } else if (dataType == "bookmark" || dataType == "error") {
    width = 300;
  } else if (dataType == "customRange") {
    width = 500;
  }

  // Determine class for OK vs Cancel/Next buttons toggling
  var popupClass = "popup ";

  if (initialDisplay) {
    popupClass += " mainPopup";
  } else {
    popupClass += " dataPopup visibilyHidden";
  }

  if (
    $.inArray(dataType, ["dataError", "metadata", "bookmark", "error"]) != -1
  ) {
    popupClass += " " + dataType;
  }

  if (dataType == "customRange") {
    popupClass += " customPopupClass";
    appendToDiv = ".popupParent";
  }

  var unhideAndShow = function() {
    $(strContainer)
      .dialog("widget")
      .position(centerPosition);
    $(strContainer)
      .dialog("widget")
      .removeClass("visibilyHidden");
  };

  var fullScreenHandler = function(event) {
    var next = $(event.target).find(".buttonNext")[0];
    if (
      arrSelectedCountryCodes.length > 0 &&
      arrSelectedIndicatorCodes.length > 0
    ) {
      if (
        mobileDetect.mobile() &&
        localStorage.getItem("fullScreenDefault") === "true"
      ) {
        toggleFullScreen();
      }
    }
  };

  g_bInitialDialog = initialDisplay;

  $(strContainer).dialog({
    dialogClass: popupClass,
    draggable: false,
    resizable: false,
    appendTo: appendToDiv,
    title: strTitle,
    width: width,
    modal: true,
    // height: 500,
    open: function(event, ui) {
      $(strContainer)
        .dialog("widget")
        .addClass("visibilyHidden");
      switch (dataType) {
        case "countries":
          $(this).load("html/countries.html", function() {
            loadCountries(true);
            $(this)
              .find(".buttonNext")[0]
              .addEventListener("click", fullScreenHandler);
            unhideAndShow();

            // We only need the guided help for this data type on the main page
            if (statCompilerDashboard.getCurrentDisplayType() == "") {
              var currLang = Config.getLanguage();
              if (localStorage.getItem("startedGuidedHelp") === "true") {
                $("#pageSizer").css("z-index", "-1");
                $(".introJsLabel").css("display", "none");
                $(".ui-dialog").addClass("introJSindexIndicator");
                introjsCountries = introJs();
                introjsCountries._options.skipLabel = Config.getUniversalString(
                  "introClose"
                );
                introjsCountries._options.nextLabel = Config.getUniversalString(
                  "introNext"
                );
                introjsCountries._options.prevLabel = Config.getUniversalString(
                  "introPrev"
                );

                introjsCountries
                  .setOptions({
                    showBullets: "false",
                    showStepNumbers: "false",
                    overlayOpacity: 0,
                    exitOnEsc: false,
                    hidePrev: true,
                    hideNext: true,
                    // "doneLabel": Config.getUniversalString("iUnderstand"),
                    steps: [
                      {
                        element: document.querySelector("#parameterPopup"),
                        intro: Config.getGuidedHelpString("ctryTour1"),
                        position: "left",
                        tooltipClass: "introJSindex",
                        exitOnOverlayClick: false
                      }
                    ]
                  })
                  .start();

                $(".introjs-helperLayer").css(
                  "background-color",
                  "rgba(255,255,255,1)"
                );
                $(".ui-selectmenu-menu ").css("z-index", "10000000");

                // Adding a checkbox

                var introHide = Config.getUniversalString("introHide");
                if ($("#neverShowAgainCountries_" + currLang).length === 0) {
                  // $(".introjs-tooltip").append('<input type="checkbox" id="neverShowAgainCountries_' + currLang +'">');
                  // $(".introjs-tooltip").append('<label class="introJsLabel" for="neverShowAgainCountries_' + currLang +'">' + introHide +'</label>');
                  // Close button top right
                  $(".introjs-tooltip").append(
                    '<div id="exit" class="exit">x</div>'
                  );

                  // add a flag when we're done
                  introjsCountries.oncomplete(function() {
                    if (
                      document.getElementById(
                        "neverShowAgainCountries_" + currLang
                      ).checked
                    ) {
                      localStorage.setItem(
                        "neverAgainCountries_" + currLang,
                        "true"
                      );
                      $(".ui-dialog").removeClass("introJSindexIndicator");
                      $("#pageSizer").css("z-index", "auto");
                    }
                  });

                  // add a flag when we exit
                  introjsCountries.onexit(function() {
                    if (
                      document.getElementById(
                        "neverShowAgainCountries_" + currLang
                      ).checked
                    ) {
                      localStorage.setItem(
                        "neverAgainCountries_" + currLang,
                        "true"
                      );
                      $(".ui-dialog").removeClass("introJSindexIndicator");
                      $("#pageSizer").css("z-index", "auto");
                    }
                  });

                  $("#exit").click(function() {
                    introJs().exit();
                    $(".ui-dialog").removeClass("introJSindexIndicator");
                    $("#pageSizer").css("z-index", "auto");
                  });

                  $("#popupNext").click(function() {
                    introjsCountries.exit();
                  });
                }
              }
            }
          });
          break;
        case "indicators":
          $(this).load("html/indicators.html", function() {
            loadIndicators(true);
            $(this)
              .find(".buttonNext")[0]
              .addEventListener("click", fullScreenHandler);
            unhideAndShow();
            $("#indicatorsSearch").focus();

            // We only need the guided help for this data type on the main page
            if (statCompilerDashboard.getCurrentDisplayType() == "") {
              var currLang = Config.getLanguage();
              $(".introjs-helperLayer").addClass("hidden");
              if (localStorage.getItem("startedGuidedHelp") === "true") {
                $("#pageSizer").css("z-index", "-1");
                $(".ui-dialog").addClass("introJSindexIndicator");
                introjsInd = introJs();
                introjsInd._options.skipLabel = Config.getUniversalString(
                  "introClose"
                );
                introjsInd._options.nextLabel = Config.getUniversalString(
                  "introNext"
                );
                introjsInd._options.prevLabel = Config.getUniversalString(
                  "introPrev"
                );

                introjsInd
                  .setOptions({
                    showBullets: "false",
                    showStepNumbers: "false",
                    exitOnEsc: false,
                    overlayOpacity: 0,
                    // "doneLabel": Config.getUniversalString("iUnderstand"),
                    exitOnOverlayClick: false,
                    steps: [
                      {
                        element: document.querySelector("#parameterPopup"),
                        intro: Config.getGuidedHelpString("indicatorTour1"),
                        position: "left",
                        tooltipClass: "introJSindex"
                      }
                    ]
                  })
                  .start();

                $(".introjs-helperLayer").css(
                  "background-color",
                  "rgba(255,255,255,.3)"
                );

                var introHide = Config.getUniversalString("introHide");
                if ($("#neverShowAgainInd_" + currLang).length === 0) {
                  // $(".introjs-tooltip").append('<input type="checkbox" id="neverShowAgainInd_' + currLang +'">');
                  // $(".introjs-tooltip").append('<label class="introJsLabel" for="neverShowAgainInd_' + currLang +'">' + introHide +'</label>');
                  // Close button top right
                  $(".introjs-tooltip").append(
                    '<div id="exit" class="exit">x</div>'
                  );

                  // add a flag when we're done
                  introjsInd.oncomplete(function() {
                    if (
                      document.getElementById("neverShowAgainInd_" + currLang)
                        .checked
                    ) {
                      localStorage.setItem("neverAgainInd_" + currLang, "true");
                      $(".ui-dialog").removeClass("introJSindexIndicator");
                      $("#pageSizer").css("z-index", "auto");
                    }
                  });

                  // add a flag when we exit
                  introjsInd.onexit(function() {
                    if (
                      document.getElementById("neverShowAgainInd_" + currLang)
                        .checked
                    ) {
                      localStorage.setItem("neverAgainInd_" + currLang, "true");
                      $(".ui-dialog").removeClass("introJSindexIndicator");
                      $("#pageSizer").css("z-index", "auto");
                    }
                  });

                  $("#exit").click(function() {
                    introJs().exit();
                    $(".ui-dialog").removeClass("introJSindexIndicator");
                    $("#pageSizer").css("z-index", "auto");
                  });
                }
              }
            }
          });

          break;
        case "metadata":
          $(this).load("html/metadata.html", function() {
            var htmlInject = "";
            var metadata = statCompilerDashboard.getIndicatorMetaData();
            var i = 0;
            for (var label in metadata) {
              var labelFilter = [
                "DenominatorWeightedId",
                "DenominatorUnweightedId",
                "IndicatorTotalId",
                "IndicatorSpecial1Id",
                "IndicatorSpecial2Id"
              ];
              if (labelFilter.indexOf(label) === -1) {
                var value = metadata[label];
                if (value !== "") {
                  if (i % 2 == 0) {
                    htmlInject += "<tr>";
                  } else {
                    htmlInject += "<tr class='alt'>";
                  }

                  htmlInject +=
                    "<td>" + Config.getUniversalString(label) + "</td>";
                  htmlInject += "<td>" + value + "</td>";
                  htmlInject += "</tr>";

                  i++;
                }
              }
            }

            $(".popup .metadata tbody").html(htmlInject);
            unhideAndShow();
            $(".popup .buttonOk").focus();
          });
          break;
        case "dataError":
          $(this).load("html/dataError.html", function() {
            unhideAndShow();
          });
          break;
        case "bookmark":
          if (!initBookmark) {
            $(this).load("html/bookmark.html", function() {
              $("#bookmarkText").val(
                statCompilerDashboard.getBookmark(document.URL)
              );

              unhideAndShow();
              $("#bookmarkText").select();
              $("#bookmarkText").focus();

              $("#bookmarkText").bind("copy.feedback", function() {
                setTimeout(function() {
                  $(".popup .caption").html("Copied successfully &#10003");
                  $(".popup .caption").addClass("success");
                  $(".popup button.tile.green").focus();
                }, 100);
              });
            });

            initBookmark = true;
          } else {
            $("#bookmarkText").val(
              statCompilerDashboard.getBookmark(document.URL)
            );
            $(".bookmark-content-container").addClass("hidden");
            $("#shareContainer").removeClass("open");
            $("#shareContainer").removeClass("hidden");

            unhideAndShow();
          }
          break;
        case "error":
          $(this).load("html/error.html", function() {
            unhideAndShow();
            // $('#bookmarkText').select();
            // $('#bookmarkText').focus();
          });
          break;
        case "breaks":
          $(this).load("html/breaks.html", function() {
            unhideAndShow();
          });
          break;
        case "mobileDetect":
          $(this).load("html/mobileDetect.html", unhideAndShow);
          break;
        case "customRange":
          $(this).load("html/customRange.html", function() {
            createTable();
            $(".check").change(function() {
              var rowid = $(this).closest("tr")[0].id;
              var colname = $(this)[0].className.split(" ")[1];

              if (
                $(this)
                  .children()
                  .is(":checked")
              ) {
                jQuery("#customTable").jqGrid("getLocalRow", rowid)[
                  colname
                ] = 1;
                $(this).children()[0].value = 1;
              } else {
                jQuery("#customTable").jqGrid("getLocalRow", rowid)[
                  colname
                ] = 0;
                $(this).children()[0].value = 0;
              }
              setSelectSurveyTypeText();
            });

            $(this)
              .find(".buttonNext")[0]
              .addEventListener("click", fullScreenHandler);
            unhideAndShow();
            // Set Select Survey Text each time popup is opened
            setSelectSurveyTypeText();
          });
          break;
        case "customBreaks":
          $(this).load("html/customBreaks.html", function() {
            unhideAndShow();
          });
      }
    },
    close: function() {
      $("#pageSizer").css("z-index", "auto");
      //If this is an initial display.
      if (initialDisplay) {
        //Make sure the dialog is not slated to be cancelled.
        if (!g_bCancelDialog) {
          //if data type is indicators
          if (dataType == "indicators") {
            //Check if Indicators have been selected.
            if (arrSelectedIndicatorCodes.length == 0) {
              $(this).empty();
              addParametersPopup(
                strContainer,
                "indicators",
                initialDisplay,
                Config.getUniversalString("selectIndicators")
              );
            }
            //Check if Countries are already selected.
            else if (arrSelectedCountryCodes.length == 0) {
              $(this).empty();
              addParametersPopup(
                strContainer,
                "countries",
                initialDisplay,
                Config.getUniversalString("selectCountries")
              );
            } else {
              $(this).empty();
              setTimeout("loadPage('data.html')", 100);
            }
          } else if (dataType == "countries") {
            //Data Type is countries.
            //Check if Countries are already selected.
            if (arrSelectedCountryCodes.length == 0) {
              $(this).empty();
              addParametersPopup(
                strContainer,
                "countries",
                initialDisplay,
                Config.getUniversalString("selectCountries")
              );
            }
            //Check if Indicators are already selected.
            else if (arrSelectedIndicatorCodes.length == 0) {
              $(this).empty();
              addParametersPopup(
                strContainer,
                "indicators",
                initialDisplay,
                Config.getUniversalString("selectIndicators")
              );
            } else {
              $(this).empty();
              setTimeout("loadPage('data.html')", 100);
            }
          }

          //Reset Cancel to Active.
          g_bCancelDialog = true;
        } else {
          //Clear Indicators/Countries.
          arrSelectedCountryCodes = [];
          arrSelectedCountryNames = [];
          arrSelectedIndicatorCodes = [];
          arrSelectedIndicatorNames = [];
        }
      } else if (dataType == "dataError") {
        // do nothing
      } else if (dataType == "bookmark") {
        toggleShareWidget();
      } else if (dataType == "metadata") {
        //do nothing.
      } else if (dataType == "mobileDetect") {
      } else {
        if (!g_bCancelDialog) {
          //Declare Important Variables.
          var bChanges = false;

          //Workflow to refresh data for Indicators.
          if (dataType == "indicators") {
            //Comparing denominators to remove previous selcted denominator data that is not being used anymore
            if (
              !compareStringArrays(
                arrPrevSelectedDenominatorIndicators,
                arrSelectedDenominatorIndicators
              )
            ) {
              RemoveAPIData("IndicatorId", g_objChanges.removed);
            }

            if (
              !compareStringArrays(
                arrPrevSelectedIndicatorCodes,
                arrSelectedIndicatorCodes
              )
            ) {
              //Remove any Indicator data for indicators that were removed.
              RemoveAPIData("IndicatorId", g_objChanges.removed);

              //Add Indicator data if there is new data requested.
              if (g_objChanges.added.length > 0) {
                AppendAPIData(
                  "indicators",
                  g_objChanges.added,
                  statCompilerDashboard.shouldLoadDenominators()
                );
              } else {
                //Update Dashboard.
                statCompilerDashboard.updateDashboard(arrData, true);

                updateSlider();
                if (arrData.length === 0) {
                  disableMenuItems();
                } else {
                  enableMenuItems();
                }
              }
            }
          } else if (dataType == "countries") {
            //Check if changes were made to countries.
            if (
              !compareStringArrays(
                arrPrevSelectedCountryCodes,
                arrSelectedCountryCodes
              )
            ) {
              //Remove any Indicator data for indicators that were removed.
              RemoveAPIData("DHS_CountryCode", g_objChanges.removed);

              //Add Indicator data if there is new data requested.
              if (g_objChanges.added.length > 0) {
                arrData = AppendAPIData(
                  "countries",
                  g_objChanges.added,
                  statCompilerDashboard.shouldLoadDenominators()
                );
              } else {
                //Update Dashboard.
                statCompilerDashboard.updateDashboard(arrData, true);
                updateSlider();
                if (arrData.length === 0) {
                  disableMenuItems();
                } else {
                  enableMenuItems();
                }
              }
            }
          } else {
            //Create new object.
            var objParams = {};
            objParams["countryIds"] = arrSelectedCountryCodes.join(",");
            var arrDenominatorIndicators = arrSelectedDenominatorIndicators
              .map(function(objRow) {
                var string =
                  objRow.IndicatorSpecial1Id !== ""
                    ? objRow.IndicatorSpecial1Id + ","
                    : "";
                string +=
                  objRow.IndicatorSpecial2Id !== ""
                    ? objRow.IndicatorSpecial2Id + ","
                    : "";
                string +=
                  objRow.IndicatorTotalId !== ""
                    ? objRow.IndicatorTotalId + ","
                    : "";
                string +=
                  objRow.DenominatorWeightedId !== ""
                    ? objRow.DenominatorWeightedId + ","
                    : "";
                string +=
                  objRow.DenominatorUnweightedId !== ""
                    ? objRow.DenominatorUnweightedId + ","
                    : "";

                return string;
              })
              .join(",");

            objParams["indicatorIds"] =
              arrSelectedIndicatorCodes.join(",") +
              "," +
              arrDenominatorIndicators;

            //Make a call to obtain all the data.
            var retData = dhsAPI.getData(
              objParams,
              true,
              showDiscreteLoader,
              hideDiscreteLoader
            );

            //Data Returned, update the dashboard.
            retData.done(function(returnData) {
              //Assign data to global for sorting and pivoting.

              arrData = returnData.Data;

              //Display Data on a grid.

              statCompilerDashboard.updateDashboard(arrData, true);
              updateSlider();

              if (returnData.Recordcount === 0) {
                disableMenuItems();
              } else {
                enableMenuItems();
              }
            }); //END retIndicators.done(...
          }

          //Reset Cancel to Active.
          g_bCancelDialog = true;
        } //END if(!g_bCancelDialog){...
        else {
          //Assign Previous Indicators and Countries.
          if (dataType == "indicators") {
            arrSelectedIndicatorCodes = arrPrevSelectedIndicatorCodes.slice(0);
          } else if (dataType == "countries") {
            arrSelectedCountryCodes = arrPrevSelectedCountryCodes.slice(0);
          } else if (dataType == "customRange") {
            // do nothing
          }
        }
      }
    }
  });
};

//! ABANDONED???!!!
var selectIndicators = function(strContainer) {
  console.error("selectIndicators exec has been called", new Date());

  ////// 	$( strContainer ).dialog({
  ////// 			dialogClass: "popup",
  ////// 			title: Config.getUniversalString("selectIndicators"),
  ////// 			width: 444,
  ////// 			appendTo: ".popupParent",
  ////// 			// height: 500,
  ////// 			open: function(event, ui) {
  ////// 					$(this).load("html/indicators.html", function() {
  ////// 							loadIndicators(true);
  ////// 					});
  ////// 			},
  ////// 			close: function() {
  ////// 				//Make sure the dialog is not slated to be cancelled.
  ////// 				if(!g_bCancelDialog){
  ////// 					//If indicators have not been already loaded, load indicators next.
  ////// 					if(arrSelectedCountryCodes.length == 0) {
  ////// 						selectCountries('#mainCountryPopup');
  ////// 					}
  ////// 					else {
  ////// 						loadPage('data.html')
  ////// 					}
  ////// 				}
  ////// 				else {
  ////// 					g_bCancelDialog = false;
  ////// 				}
  ////// 			}
  ////// 	});
};

/*****************************************************************
function:   selectCountries
Desc.:      Function to initially select countries.
return:     void
//! ABANDONED???!!!
*****************************************************************/
var selectCountries = function(strContainer) {
  console.error("selectCountries exec has been called", new Date());
  //////		$( strContainer ).dialog({
  //////				dialogClass: "popupIndicatorPopup",
  //////				title: Config.getUniversalString("selectCountries"),
  //////				width: 444,
  //////				appendTo: ".popupParent",
  //////				height: 470,
  //////				open: function(event, ui) {
  //////						$(this).load("html/countries.html", function() {
  //////								loadCountries(true);
  //////						});
  //////				},
  //////				close: function() {
  //////					//Make sure the dialog is not slated to be cancelled.
  //////					if(!g_bCancelDialog){
  //////						//If indicators have not been already loaded, load indicators next.
  //////						if(arrSelectedIndicatorCodes.length == 0) {
  //////							selectIndicators('#mainIndicatorPopup');
  //////						}
  //////						else {
  //////							loadPage('data.html')
  //////						}
  //////					}
  //////					else {
  //////						g_bCancelDialog = false;
  //////					}
  //////				}
  //////		});
};

/*****************************************************************
function:   loadCountriesData
Desc.:      Load Countries from the API.
*****************************************************************/
var loadCountriesData = function() {
  //Make a call to obtain a list of countries.
  var retCountries = dhsAPI.getCountries(null);

  //Countries Returned, populate the Region/Countries List.
  retCountries.done(function(countriesData) {
    //Get Surveys data as well.
    var objParams = { returnFields: "DHS_CountryCode" };
    var retSurveys = dhsAPI.getSurveys(objParams);

    retSurveys.done(function(surveyData) {
      var objNumSurveys = calculateSurveysPerCountry(surveyData.Data);

      //First sort the data according to region order.
      sortAPIData(countriesData.Data, ["RegionOrder", "CountryName"], true);
      //Empty the Countries Object.
      objCountries = [];

      //Loop through the array of data objects.
      $.each(countriesData.Data, function(index, value) {
        //if(value.DHS_CountryCode === 'CI'){value.CountryName = "Cote d'Ivoire";}
        //Check if the country has any survey data, before adding it.
        if (objNumSurveys[value.DHS_CountryCode] > 0) {
          //Check if the Region Exists.
          if (
            nameValueLib.objectExists(objCountries, [value.RegionName]) == -1
          ) {
            //Create New Object for Region and add it to list.
            var newObj = nameValueLib.createObject(
              value.RegionName,
              "",
              nameValueLib.createObject(
                value.SubregionName,
                "",
                nameValueLib.createObject(
                  value.CountryName,
                  objNumSurveys[value.DHS_CountryCode],
                  value.DHS_CountryCode,
                  true
                ),
                true
              ),
              false
            );
            //Add to Countries.
            objCountries.push(newObj);
          } else if (
            nameValueLib.objectExists(objCountries, [
              value.RegionName,
              value.SubregionName
            ]) == -1
          ) {
            //Obtain the Region Array.
            var arrRegion = nameValueLib.getValue(objCountries, [
              value.RegionName
            ]);

            //Create new Sub Region Object.
            var newObj = nameValueLib.createObject(
              value.SubregionName,
              "",
              nameValueLib.createObject(
                value.CountryName,
                objNumSurveys[value.DHS_CountryCode],
                value.DHS_CountryCode,
                true
              ),
              false
            );

            //Add new Sub Region to Region.
            arrRegion.push(newObj);
          } else {
            //Get Sub Region Array.
            var arrSubRegion = nameValueLib.getValue(objCountries, [
              value.RegionName,
              value.SubregionName
            ]);

            //Create a country object.
            var newObj = nameValueLib.createObject(
              value.CountryName,
              objNumSurveys[value.DHS_CountryCode],
              value.DHS_CountryCode,
              false
            );

            //Add new country to sub region.
            arrSubRegion.push(newObj);
          }
        } //END if(objNumSurveys[value.DHS_CountryCode] > 0) {...
      });

      // This function normalizes objCountries into a collection (array of objects). objCountries is *actually* a nested object with regions as keys and countries as values.
      // This returns the arrays of countries at the base of the objects and flattens them into a normalized collection of countries.

      var recursor = function(v) {
        var testv = v.value;
        while (_.isArray(testv[0])) {
          testv = v.value;
        }
        return testv.map(function(vv) {
          return vv.value;
        });
      };
      window.global_all_countries = _.flatten(
        _.flatMap(objCountries, recursor)
      );

      //Flag countries data as loaded.

      bCountryDataLoaded = true;
    }); //End Surveys .done
  }); //End Countries .done

  //Handle Errors.
  retCountries.fail(function(value) {});
}; //END loadCountriesData

/*****************************************************************
function:   loadIndicatorsDataV2
Desc.:      Initialize and populate the indicators Data.
*****************************************************************/
var loadIndicatorsData = function() {
  //Create new object.
  var objParams = {};
  var arrTags = [];
  var retIndicators;
  objParams["returnFields"] =
    "IndicatorId,Label,IndicatorSpecial1Id,IndicatorSpecial2Id,DenominatorWeightedId,IndicatorTotalId,DenominatorUnweightedId,Level1,Level2,Level3,IndicatorOldId,ShortName,MeasurementType,NumberScale,Definition,IsQuickStat,IndicatorType,SDRID,TagIds,QuickStatOrder,Denominator,DenominatorUnweighted,DenominatorWeightedId";
  //Make a call to obtain a list of Tags.
  var retTags = dhsAPI.getTags(objParams);

  //Tags Returned, process it and obtain the indicators
  retTags.done(function(returnData) {
    for (var nIndex = 0; nIndex < returnData.Data.length; nIndex++) {
      //Get Current Row.
      var objValue = returnData.Data[nIndex];

      //Filter DHS Internal Tags
      if (objValue.TagType != 2) {
        //Create Object.
        var objTag = nameValueLib.createObject(
          objValue.TagID,
          objValue.TagOrder,
          objValue.TagName,
          false
        );
        //Add it to Tags Array.
        arrTags.push(objTag);
      }
    }

    //Make a call to obtain a list of Indicators.
    var retIndicators = dhsAPI.getIndicators(objParams);

    //Indicators returned, populate the Levels/Indicators List.
    retIndicators.done(function(returnData) {
      //Loop through the array of data objects.
      $.each(returnData.Data, function(index, value) {
        //Only utilize the indicators with Indicator Type "I"
        if (
          value.IndicatorType === "I" ||
          value.IndicatorType === "D" ||
          value.IndicatorType === "U" ||
          value.IndicatorType === "S" ||
          value.IndicatorType === "T"
        ) {
          ///////////////////////////////////////////////////
          //
          // Add to the Measurement Type Indicator List.
          //
          //////////////////////////////////////////////////
          if (
            nameValueLib.objectExists(arrIndicatorMeasurementType, [
              value.Label
            ]) == -1
          ) {
            var newObj = nameValueLib.createObject(
              value.Label,
              value.IndicatorId,
              value.MeasurementType
            );
            arrIndicatorMeasurementType.push(newObj);
          }

          ///////////////////////////////////////////////////
          //
          // Add to the QuickStat Indicator List.
          //
          //////////////////////////////////////////////////
          if (value.IsQuickStat == 1) {
            if (
              nameValueLib.objectExists(arrCommonIndicatorList, [
                value.IndicatorId
              ]) == -1
            ) {
              var newObj = nameValueLib.createObject(
                value.IndicatorId,
                value.QuickStatOrder,
                value.Label
              );

              arrCommonIndicatorList.push(newObj);
            }
          }

          ///////////////////////////////////////////////////
          //
          // Add to the Indicator by Tag List.
          //
          //////////////////////////////////////////////////
          //Obtain List of tags associated with this indicator.
          var arrIndicatorTags = [];
          if (isNaN(value.TagIds)) {
            value.TagIds.replace(/ /g, "");
            var arrIndicatorTags = value.TagIds.split(",");
          } else {
            var strTag = value.TagIds.toString();
            if (strTag.length) {
              arrIndicatorTags.push(value.TagIds.toString());
            }
          }

          //Go through each tag and make sure the indicator is added to that list.
          for (var nIndex = 0; nIndex < arrIndicatorTags.length; nIndex++) {
            //Obtain the Tag Object from the Tag Array.
            var objCurTag = nameValueLib.getObject(arrTags, [
              arrIndicatorTags[nIndex]
            ]);

            //if tag was found, add indicator to it.
            if (objCurTag != null) {
              //If Tag does not exist.
              if (
                nameValueLib.objectExists(arrIndicatorByTagList, [
                  objCurTag.value
                ]) == -1
              ) {
                var newObj = nameValueLib.createObject(
                  objCurTag.value,
                  objCurTag.alias,
                  nameValueLib.createIndicatorObject(
                    value.IndicatorId,
                    "",
                    value.Label,
                    true,
                    value.IndicatorType
                  ),
                  false
                );
                arrIndicatorByTagList.push(newObj);
              }

              //if Indicator does not exist.
              else if (
                nameValueLib.objectExists(arrIndicatorByTagList, [
                  objCurTag.value,
                  value.IndicatorId
                ]) == -1
              ) {
                var arrLvlIndicators = nameValueLib.getValue(
                  arrIndicatorByTagList,
                  [objCurTag.value]
                );
                var newObj = nameValueLib.createIndicatorObject(
                  value.IndicatorId,
                  "",
                  value.Label,
                  false,
                  value.IndicatorType
                );
                arrLvlIndicators.push(newObj);
              }
            }
          } //END for(var nIndex = 0...

          ///////////////////////////////////////////////////
          //
          // Add to the Complete Indicator List.
          //
          //////////////////////////////////////////////////
          //If Level 1 does not exist.
          if (
            nameValueLib.objectExists(arrCompleteIndicatorList, [
              value.Level1
            ]) == -1
          ) {
            var newObj = nameValueLib.createObject(
              value.Level1,
              "",
              nameValueLib.createObject(
                value.Level2,
                "",
                nameValueLib.createObject(
                  value.Level3,
                  "",
                  nameValueLib.createIndicatorObject(
                    value.IndicatorId,
                    "",
                    value.Label,
                    true,
                    value.IndicatorType
                  ),
                  true
                ),
                true
              ),
              false
            );
            arrCompleteIndicatorList.push(newObj);
          }
          //If Level 2 does not exist.
          else if (
            nameValueLib.objectExists(arrCompleteIndicatorList, [
              value.Level1,
              value.Level2
            ]) == -1
          ) {
            var arrLevel2 = nameValueLib.getValue(arrCompleteIndicatorList, [
              value.Level1
            ]);
            var newObj = nameValueLib.createObject(
              value.Level2,
              "",
              nameValueLib.createObject(
                value.Level3,
                "",
                nameValueLib.createIndicatorObject(
                  value.IndicatorId,
                  "",
                  value.Label,
                  true,
                  value.IndicatorType
                ),
                true
              ),
              false
            );
            arrLevel2.push(newObj);
          }
          //if Level 3 does not exist.
          else if (
            nameValueLib.objectExists(arrCompleteIndicatorList, [
              value.Level1,
              value.Level2,
              value.Level3
            ]) == -1
          ) {
            var arrLevel3 = nameValueLib.getValue(arrCompleteIndicatorList, [
              value.Level1,
              value.Level2
            ]);
            var newObj = nameValueLib.createObject(
              value.Level3,
              "",
              nameValueLib.createIndicatorObject(
                value.IndicatorId,
                "",
                value.Label,
                true,
                value.IndicatorType
              ),
              false
            );
            arrLevel3.push(newObj);
          }
          //if Indicator does not exist.
          else if (
            nameValueLib.objectExists(arrCompleteIndicatorList, [
              value.Level1,
              value.Level2,
              value.Level3,
              value.IndicatorId
            ]) == -1
          ) {
            var arrLvlIndicators = nameValueLib.getValue(
              arrCompleteIndicatorList,
              [value.Level1, value.Level2, value.Level3]
            );
            var newObj = nameValueLib.createIndicatorObject(
              value.IndicatorId,
              "",
              value.Label,
              false,
              value.IndicatorType
            );
            arrLvlIndicators.push(newObj);
          }

          ///////////////////////////////////////////////////
          //
          // Add to the Meta Data Array.
          //
          //////////////////////////////////////////////////
          var objValue = {};
          objValue["Indicator"] = value.Label;
          objValue["Measure"] = value.MeasurementType;
          objValue["Definition"] = value.Definition;
          objValue["Denominator"] = value.Denominator;
          objValue["Group"] = value.Level1 + ": " + value.Level2;

          switch (value.IndicatorType) {
            case "I":
              objValue["Type"] = Config.getUniversalString("Indicator");
              break;
            case "S":
              objValue["Type"] = Config.getUniversalString("special");
              break;
            case "T":
              objValue["Type"] = Config.getUniversalString("total");
              break;
            case "D":
              objValue["Type"] = Config.getUniversalString("Denominator");
              break;
            case "U":
              objValue["Type"] = Config.getUniversalString("unweightedDen");
              break;
            case "N":
              objValue["Type"] = Config.getUniversalString("number");
              break;
            default:
              objValue["Type"] = "N/A";
              break;
          }
          objValue["Decimals"] = value.NumberScale;
          objValue["Indicator_ID"] = value.IndicatorId;
          objValue["DenominatorWeightedId"] = value.DenominatorWeightedId;
          objValue["DenominatorUnweightedId"] = value.DenominatorUnweightedId;
          objValue["IndicatorTotalId"] = value.IndicatorTotalId;
          objValue["IndicatorSpecial1Id"] = value.IndicatorSpecial1Id;
          objValue["IndicatorSpecial2Id"] = value.IndicatorSpecial2Id;

          var objTemp = nameValueLib.createObject(
            value.Label,
            value.IndicatorId,
            objValue,
            false
          );
          arrIndicatorMetaData.push(objTemp);

          ///////////////////////////////////////////////////
          //
          // Add to the Denominator Array.
          //
          //////////////////////////////////////////////////
          // //Add the indicator with all the meta data.
          objMetaData = {};
          objMetaData["DenominatorWeightedId"] = value.DenominatorWeightedId;
          objMetaData["DenominatorUnweightedId"] =
            value.DenominatorUnweightedId;
          objMetaData["IndicatorTotalId"] = value.IndicatorTotalId;
          objMetaData["IndicatorSpecial1Id"] = value.IndicatorSpecial1Id;
          objMetaData["IndicatorSpecial2Id"] = value.IndicatorSpecial2Id;
          objIndicatorDenominatorInfo[value.IndicatorId] = objMetaData;
        } //End if (value.IndicatorType...
      });

      //Flag indicator data is loaded.
      bIndicatorDataLoaded = true;
      statCompilerDashboard.createTotalRegistry();

      //Hide the Loader Div.
      var waitLoader = $(".waitLoader");
      if (waitLoader.length === 0) {
        var interval = setInterval(function() {
          if ($(".waitLoader").length > 0) {
            $(".waitLoader").addClass("hidden");
            clearInterval(interval);
          }
        }, 5000);
      } else {
        waitLoader.addClass("hidden");
      }

      //Sort the Tag Indicator List data by Tag Order.
      sortAPIDataEX(arrIndicatorByTagList, ["alias"], ["number"], true);

      //Sort the Common Indicator List data by Quickstat Order.
      sortAPIDataEX(arrCommonIndicatorList, ["alias"], ["number"], true);
      var dhsAPI_allCountries = dhsAPI.allCountries();

      //! README
      // What is loadFromHash ?? recipe for creating a race condition.
      if (loadFromHash) {
        dhsAPI_allCountries.done(initHash);
      }
    }); //END retIndicators.done(...

    //Handle Errors.
    retIndicators.fail(function(value) {});
  }); //END retTags.done(...

  //Handle Errors.
  retTags.fail(function(value) {});
};

/*****************************************************************
function:   proceedWithTool
Desc.:      Function to proceed to the next step of the tool.
return:     void
*****************************************************************/
var proceedWithTool = function(dialogName) {
  //Setup the Cancel Tool Indicator to true.
  g_bCancelDialog = false;

  //Close the Dialog.
  $(dialogName).dialog("close");
};

/*****************************************************************
function:   sortAPIData
Desc.:      Function to help sort the data anyway you prefer.
param:      json_data: The "Data" property of the JSON returned
						from the API.
param:      sort_properties: An array providing a list of
						properties to sort the data by.
return:     Returns JSON data sorted by the properties provided.
*****************************************************************/
var sortAPIData = function(json_data, sort_properties, asc) {
  var nSortIndexSize = sort_properties.length;
  var ordArr = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "AaÁáÂâÀàÃã",
    "Bb",
    "CcÇç",
    "Dd",
    "EeÉéÈèÊêËë",
    "Ff",
    "Gg",
    "Hh",
    "IiÍíÏïÎî",
    "Jj",
    "Kk",
    "Ll",
    "Mm",
    "NnÑñ",
    "OoÓóÔô",
    "Pp",
    "Qq",
    "Rr",
    "Ss",
    "Tt",
    "UuÚúÙùÛûÜü",
    "Vv",
    "Ww",
    "Xx",
    "Yy",
    "Zz"
  ];
  var sortFunc = _getLocaleStrCmpFn(ordArr);

  json_data = json_data.sort(function(a, b) {
    for (var nIndex = 0; nIndex < nSortIndexSize; nIndex++) {
      //If Sort Property is a String.
      if (typeof a[sort_properties[nIndex]] === "number") {
        if (a[sort_properties[nIndex]] > b[sort_properties[nIndex]]) {
          return 1;
        } else if (a[sort_properties[nIndex]] < b[sort_properties[nIndex]]) {
          return -1;
        }
      } else {
        var jj = sortFunc(a, b, sort_properties[nIndex]);

        return jj;
      }
    }
    return 0;
  });
};

/*****************************************************************
function:   sortAPIDataEX
Desc.:      Function to help sort the data anyway you prefer.
param:      json_data: The "Data" property of the JSON returned
						from the API.
param:      sort_properties: An array providing a list of
						properties to sort the data by.
param:      sortproperties_typeof: An array providing a list of
						types corresponding to the properties
						specified in the previous argument.
						E.g. Prpoerty type is either "string"
						, "number" or null. If null, type of
						is determined automatically.
return:     Returns JSON data sorted by the properties provided.
*****************************************************************/
var sortAPIDataEX = function(
  json_data,
  sort_properties,
  sortproperties_typeof
) {
  var nSortIndexSize = sort_properties.length;
  var ordArr = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "AaÁáÂâÀàÃã",
    "Bb",
    "CcÇç",
    "Dd",
    "EeÉéÈèÊêËë",
    "Ff",
    "Gg",
    "Hh",
    "IiÍíÏïÎî",
    "Jj",
    "Kk",
    "Ll",
    "Mm",
    "NnÑñ",
    "OoÓóÔô",
    "Pp",
    "Qq",
    "Rr",
    "Ss",
    "Tt",
    "UuÚúÙùÛûÜü",
    "Vv",
    "Ww",
    "Xx",
    "Yy",
    "Zz"
  ];
  var sortFunc = _getLocaleStrCmpFn(ordArr);

  json_data = json_data.sort(function(a, b) {
    for (var nIndex = 0; nIndex < nSortIndexSize; nIndex++) {
      //If typeof is specified, use it.
      if (sortproperties_typeof[nIndex] != null) {
        if (sortproperties_typeof[nIndex] === "number") {
          if (
            parseFloat(a[sort_properties[nIndex]]) >
            parseFloat(b[sort_properties[nIndex]])
          ) {
            return 1;
          } else if (
            parseFloat(a[sort_properties[nIndex]]) <
            parseFloat(b[sort_properties[nIndex]])
          ) {
            return -1;
          }
        } else {
          aFrench = a[sort_properties[nIndex]];
          bFrench = b[sort_properties[nIndex]];
          if (aFrench.charAt(0) == "É") {
            aFrench = aFrench.replace(aFrench.charAt(0), "E");
          }
          if (bFrench.charAt(0) == "É") {
            bFrench = bFrench.replace(bFrench.charAt(0), "E");
          }

          if (aFrench > bFrench) {
            // && a[sort_properties[nIndex]].charAt(0) != "É"
            return 1;
          } else if (aFrench < bFrench) {
            return -1;
          }
        }
      } else {
        var jj = sortFunc(a, b, sort_properties[nIndex]);
        return jj;
      }
    }
    return 0;
  });
};

/*****************************************************************
function:   sortAPIDataEX2
Desc.:      Function to help sort the data anyway you prefer.
param:      json_data: array of objects
param:      sort_properties: An array providing a list of
						properties to sort the data by.
param:      sortproperties_typeof: An array providing a list of
						types corresponding to the properties
						specified in the previous argument.
						E.g. Property type is either "string"
						, "number" or null. If null, type of
						is determined automatically.
return:     Returns JSON data sorted by the properties provided.
*****************************************************************/
function sort_by_props(arr_data, props) {
  // Account for diacritic marks in CountryName and sort by that instead
  var country_name_index = _.indexOf(props, "CountryName");
  if (country_name_index > -1) {
    for (var i in arr_data) {
      arr_data[i].CountryNameSort = _.deburr(arr_data[i].CountryName);
    }
    props[country_name_index] = "CountryNameSort";
  }
  var sort_directions = [];
  for (var i in props) {
    sort_directions.push("asc");
  }
  return _.orderBy(arr_data, props, sort_directions);
}

var sortAPIDataEX2 = function(
  json_data,
  sort_properties,
  sortproperties_typeof
) {
  return sort_by_props(json_data, sort_properties);
};

/*****************************************************************
function:   getQueryVariable
Desc.:      Returns functions for custom locale string comparison
			and sorting.
param:      orderArr:
				An ordered array representing the characters to
				use for sorting data.
param:      arrPropeties:
				An array of properties to specify which property
				to sort the objects on.
param:      startChar:
				Provide the start of the sorting array. Default
				is first character.
return:     An array of functions that can be used for sorting.
*****************************************************************/
var _getLocaleStrCmpFn = function(orderArr, startChar) {
  var map = [];
  for (var i = 0; i < orderArr.length; i++) {
    var chars = "" + orderArr[i];
    for (var j = 0; j < chars.length; j++) {
      if (startChar === undefined) {
        startChar = chars.charAt(j);
      }
      map[chars.charAt(j)] = i + 1;
    }
  }

  return function(objectA, objectB, strProperty) {
    a = "" + objectA[strProperty];
    b = "" + objectB[strProperty];
    var len = a.length < b.length ? a.length : b.length;
    var ca, cb, va, vb;
    for (var i = 0; i < len; i++) {
      ca = a.charAt(i);
      cb = b.charAt(i);
      if (a.charAt(0) == "É" || b.charAt(0) == "É") {
      }
      va = map[ca];
      vb = map[cb];
      if (va && vb) {
        if (va > vb) return 1;
        else if (va < vb) return -1;
      } else {
        if (va) ca = startChar;
        if (vb) cb = startChar;
        if (ca > cb) return 1;
        else if (ca < cb) return -1;
      }
    }
    if (a.length > b.length) return 1;
    else if (a.length < b.length) return -1;
    return 0;
  };
};

/*****************************************************************
function:   getQueryVariable
Desc.:      Helper function to obtain variables from the query
			parameters in a URL.
param:      variable: The variable you want to obtain data for
						from the query parameters.
return:     Returns string specifying the value of the parameter.
			Empty string if variable is not found.
*****************************************************************/
var getQueryVariable = function(variable) {
  var query = hash || window.location.search.slice(1).toString(); // 'hash' variable is set at the top of the file, but is undefined under some conditions. So duplicate here if that is the case, and also make this a "true" function.
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
};

var ie9Loader = function() {
  $(".spinner").html("<img src='images/ellipsis.gif' />");
  // Animate to 300px wide
  // .animate({ width:    50 }, 2000)  // Then, to 50px wide
  // .animate({ opacity: .25 }, 1000); // Then, make it semi-transparen
};
/*****************************************************************
function:   convertToInt
Desc.:      Function to determine whether a variable is an integer
param:      n: The variable you want to check.
return:     Returns true if value is an integer. false otherwise.
*****************************************************************/
function convertToInt(n) {
  return parseInt(n) || 0;
}

/*****************************************************************
function:   sleep
Desc.:      Function to help sleep for the allotted time.
param:      milliseconds: The number of millseconds you want to wait for.
return:     void
*****************************************************************/
function sleep(milliseconds) {
  var start = new Date().getTime();
  while (new Date().getTime() - start <= milliseconds) {}
}

/*****************************************************************
function:   calculateSurveysPerCountry
Desc.:      Function to calculate how many surveys are there /country
param:      surveyData: Array of survey data returned from the API
return:     Object specifying countryCode with number of surveys.
*****************************************************************/
function calculateSurveysPerCountry(surveyData) {
  //Declare Important Variables.
  var objNumSurveys = {};

  $.each(surveyData, function(index, objSurvey) {
    //if Country does not exist, add the first survey.
    if (typeof objNumSurveys[objSurvey.DHS_CountryCode] == "undefined") {
      objNumSurveys[objSurvey.DHS_CountryCode] = 1;
    } else {
      //Increment Survey.
      objNumSurveys[objSurvey.DHS_CountryCode] += 1;
    }
  });

  return objNumSurveys;
}

/*****************************************************************
function:   compareStringArrays
Desc.:      Function to compare two string arrays. Return true
			if the array data is the same, false otherwise.
param:      prevArray: Array of the original data (string format).
param:      newArray: Array of the new data (string format).
param:      objCompare: An empty object passed in that is filled
			with the following attributes:
			added: <An array of new values added to newArray>
			removed: <An array of values removed from newArray>
return:     Boolean, true if no change, false otherwise.
*****************************************************************/
function compareStringArrays(prevArray, newArray) {
  //Declare Important Variables.
  var arrAdded = [];
  var arrRemoved = [];

  //Initialize Compare Object.
  g_objChanges = {};

  //Go through and make sure that everything in the previous array
  //still exists in the new Array.
  for (var i = 0; i < prevArray.length; i++) {
    if (newArray.indexOf(prevArray[i]) == -1) {
      arrRemoved.push(prevArray[i]);
    }
  }

  //If there are no removed items and the new array is greater in length, find additional items.
  if (
    arrRemoved.length > 0 ||
    (arrRemoved.length == 0 && prevArray.length < newArray.length)
  ) {
    for (var i = 0; i < newArray.length; i++) {
      if (prevArray.indexOf(newArray[i]) == -1) {
        arrAdded.push(newArray[i]);
      }
    }
  }

  //Create Compare Object.
  g_objChanges["added"] = arrAdded;
  g_objChanges["removed"] = arrRemoved;

  //Return true if no elements were removed or added.
  if (arrAdded.length == 0 && arrRemoved.length == 0) {
    return true;
  } else {
    return false;
  }
}

/*****************************************************************
function:   RemoveAPIData
Desc.:      Function to remove data based on attribute value.
param:      attributeName:
param:      arrAtrributeValues:
*****************************************************************/
function RemoveAPIData(attributeName, arrAtrributeValues) {
  //Declare Important Variables.
  var arrNewData = arrData;

  //Go through each attribute value and remove it from the data.
  for (var nIndex = 0; nIndex < arrAtrributeValues.length; nIndex++) {
    //Obtain Attribute Value.
    var attribVal = arrAtrributeValues[nIndex];

    //Remove from data array.
    var result = $.grep(arrNewData, function(e) {
      return e[attributeName] != attribVal;
    });

    //Assign new array.
    arrNewData = result;

    //If denominator: remove from LoadedIndicatorArray as well.
    if (attributeName === "IndicatorId") {
      var nFoundIndex = arrLoadedDenominatorIndicators.indexOf(attribVal);
      if (nFoundIndex != -1) {
        arrLoadedDenominatorIndicators.splice(nFoundIndex, 1);
      }
    }
  }

  arrData = arrNewData;
}

/*****************************************************************
function:   AppendAPIData
Desc.:      Function to append new data to original data.
param:      addedAttribName: Attribute to which new data has been added.
param:      arrAtrributeValues: Array of values for the added attribute.
*****************************************************************/
function AppendAPIData(
  addedAttribName,
  arrAtrributeValues,
  shouldLoadDenominators
) {
  //Create new object.
  var objParams = {};
  var arrFinalIndicators = [];

  //I HAVE NO IDEA WHAT THIS DOES. Sean
  var arrDenominatorIndicators = arrSelectedDenominatorIndicators.map(function(
    objRow
  ) {
    var string = "";
    if (typeof objRow === "object") {
      string =
        objRow.IndicatorSpecial1Id !== ""
          ? objRow.IndicatorSpecial1Id + ","
          : "";
      string +=
        objRow.IndicatorSpecial2Id !== ""
          ? objRow.IndicatorSpecial2Id + ","
          : "";
      string +=
        objRow.IndicatorTotalId !== "" ? objRow.IndicatorTotalId + "," : "";
      string +=
        objRow.DenominatorUnweightedId !== ""
          ? objRow.DenominatorUnweightedId + ","
          : "";
      string +=
        objRow.DenominatorWeightedId !== "" ? objRow.DenominatorWeightedId : "";
    } else {
      string = objRow;
    }

    return string;
  });

  if (addedAttribName == "countries") {
    objParams["countryIds"] = arrAtrributeValues.join(",");
    if (shouldLoadDenominators) {
      //As you are loading new countries and denominators need to be loaded,
      //load data for new countries with denominators.
      arrFinalIndicators = [].concat(
        arrSelectedIndicatorCodes,
        arrLoadedDenominatorIndicators
      );
    } else {
      //Denominators need not be loaded, so just load main indicators.
      arrFinalIndicators = arrSelectedIndicatorCodes;
    }

    objParams["indicatorIds"] = arrFinalIndicators.join(",");
  } else {
    //Loading new Indicators.
    objParams["countryIds"] = arrSelectedCountryCodes.join(",");
    if (shouldLoadDenominators) {
      //Filter Denominators already loaded.
      for (
        var nIndex = 0;
        nIndex < arrLoadedDenominatorIndicators.length;
        nIndex++
      ) {
        //Get current loaded Denominator.
        var curIndicator = arrLoadedDenominatorIndicators[nIndex];

        //Delete from array if present.
        var nFoundIndex = arrDenominatorIndicators.indexOf(curIndicator);
        if (nFoundIndex != -1) {
          arrDenominatorIndicators.splice(nFoundIndex, 1);
        }
      }

      //Setup the final set of indicators to be loaded.
      arrFinalIndicators = [].concat(
        arrAtrributeValues,
        arrDenominatorIndicators
      );
    } else {
      arrFinalIndicators = arrAtrributeValues;
    }

    objParams["indicatorIds"] = arrFinalIndicators.join(",");
  }

  //Confirm both indicators and countries are present before calling get data.
  if (objParams.countryIds.length > 0 && objParams.indicatorIds.length > 0) {
    //Append data for any indicators that were added.
    var retData = dhsAPI.getData(
      objParams,
      true,
      showDiscreteLoader,
      hideDiscreteLoader,
      arrData
    );

    //Data Returned, update the dashboard.
    retData.done(function(returnData) {
      //If data is successful. record in Analytics.
      var strLabel =
        "countryIds:" +
        objParams.countryIds +
        ";indicatorsIds:" +
        objParams.indicatorIds;
      if (window.ga) {
        ga("send", "event", "Query", "getData", strLabel);
      }
      if (window.gtag) {
        gtag("event", "getData", {
          event_label: "Query",
          event_value: strLabel
        });
      }

      //Added the denominators that were loaded to the already loaded array.
      if (shouldLoadDenominators) {
        arrLoadedDenominatorIndicators.push.apply(
          arrLoadedDenominatorIndicators,
          arrDenominatorIndicators
        );
      }

      //Sort API Data.
      //sortAPIData(returnData.Data, ['CountryName', 'IndicatorId', 'SurveyId', 'CharacteristicId', 'CharacteristicOrder'], true);
      // sortAPIData(returnData.Data, ['CountryName', 'SurveyId', 'CharacteristicOrder'], true);
      sortAPIDataEX(
        returnData.Data,
        [
          "CountryName",
          "SurveyYear",
          "SurveyId",
          "CharacteristicOrder",
          "ByVariableId"
        ],
        ["string", "number", "string", "number", "number"],
        true
      );

      //Assign data to global for sorting and pivoting.
      arrData = returnData.Data;

      //Update Dashboard.
      statCompilerDashboard.updateDashboard(arrData, true);

      //Update to Recent Surveys.
      updateSlider();
      if (returnData.Recordcount === 0) {
        disableMenuItems();
      } else {
        enableMenuItems();
      }

      hideLoader();
    }); //END retIndicators.done(...
  } else {
    statCompilerDashboard.updateDashboard(null, true);
    hideLoader();
  }
}

/*****************************************************************
function:   getArrayIndex
Desc.:      Function to figure out where in the array a number will fit.
param:      srcArray: An array of integers.
param:      newValue: An integer that needs to be added to the array of integers
*****************************************************************/
function getSortedArrayIndex(srcArray, newValue, descending) {
  //Declare Important Variables.
  var nArrayLength = srcArray.length;
  var bFound = false;
  var nNewIndex = -1;

  //Sort Ascending order by default.
  if (typeof descending === "undefined") {
    for (nCurIndex = 0; nCurIndex < nArrayLength; nCurIndex++) {
      //If the old value is great than the value at current index.
      //you have found the insert index.
      if (parseInt(srcArray[nCurIndex]) > parseInt(newValue)) {
        nNewIndex = nCurIndex;
        break;
      }
    }
  } else {
    //Sort descending.
    for (nCurIndex = 0; nCurIndex < nArrayLength; nCurIndex++) {
      //If the new value is greater than the value at current index.
      //you have found the insert index.
      if (parseInt(newValue) > parseInt(srcArray[nCurIndex])) {
        nNewIndex = nCurIndex;
        break;
      }
    }
  }

  return nNewIndex;
}

/***********************************************************************
function:   getSortedObjectArrayIndex
Desc.:      Function to figure out where in the array a text will fit.
param:      srcArray: An array of objects.
param:      searchKey: The key to search on for sorting.
param:      newValue: The key value that needs to be added.
param:      descending: Specifying whether the sort is ascending or descneding.
*****************************************************************/
function getSortedObjectArrayIndex(srcArray, searchKey, newValue, descending) {
  //Declare Important Variables.
  var nArrayLength = srcArray.length;
  var bFound = false;
  var nNewIndex = nArrayLength;

  //Sort Ascending order by default.
  if (typeof descending === "undefined") {
    for (nCurIndex = 0; nCurIndex < nArrayLength; nCurIndex++) {
      //If the old value is great than the value at current index.
      //you have found the insert index.
      if (srcArray[nCurIndex][searchKey] > newValue) {
        nNewIndex = nCurIndex;
        break;
      }
    }
  } else {
    //Sort descending.
    for (nCurIndex = 0; nCurIndex < nArrayLength; nCurIndex++) {
      //If the new value is greater than the value at current index.
      //you have found the insert index.
      if (parseInt(newValue) > srcArray[nCurIndex][searchKey]) {
        nNewIndex = nCurIndex;
        break;
      }
    }
  }

  return nNewIndex;
}

function disableMenuItems() {
  //alert("disable")
  $("#optionsMenu").css("opacity", ".25");
  document.getElementById("optionsButton").onclick = function() {
    return false;
  };
  $("#exportsMenu").css("opacity", ".25");
  document.getElementById("exportButton").onclick = function() {
    return false;
  };
  $("#shareButton").attr("disabled", true);
  $("#selectPivot").css("opacity", ".25");
}

function enableMenuItems() {
  $("#optionsMenu").css("opacity", "1");
  document.getElementById("optionsButton").onclick = function() {
    $("#optionsMenu").toggleClass("open");
  };
  $("#exportsMenu").css("opacity", "1");
  document.getElementById("exportButton").onclick = function() {
    $("#exportsMenu").toggleClass("open");
  };
  $("#shareButton").removeAttr("disabled");
  $("#selectPivot").css("opacity", "1");
}

$(document).on("click", ".toggleOpenClass", function(e) {
  e.stopPropagation();
  $(this).toggleClass("open");
});

// The next two handlers are to ensure the select#byVariableSelect get focus when open and visible.
// Otherwise, it's text color cannot be altered.
$(document).on("focus", ".neighbor-focus-open", function() {
  $("#byVariableSelect").focus();
});

$(document).on("mouseenter", "#byVariableSelect", function() {
  $(this).focus();
});

$(document).on("mouseleave", "#byVariableSelect", function() {
  $(this).blur();
});

$(document).on("click", "[disabled]", function(e) {
  e.preventDefault();
  return;
});
